import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-apple-icon',
  standalone: false,
  templateUrl: './apple-icon.component.html',
  styleUrl: './apple-icon.component.scss'
})
export class AppleIconComponent {
  @Input('classes')
  public classes = 'w-24px h-24px';
}
